/*eslint-disable */

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import { bus } from '@/main';
import {
  mapGetters
} from 'vuex';
import mobileMenuBar from '../mobile-menu-view/';
import responsiveMixin from '@/mixins/responsive';

const $ = window.jQuery = require('jquery');
export default {
  name: 'lymphomap-header',
  mixins: [responsiveMixin],
  components: {
    mobileMenuBar,
    'access-feature-of-blurb' : accessFeaturesForBlurb
  },
  props: [],
  data () {
    return {
      showBtn:true,
      selfUserInfo:null,
      accessFeaturesOfPackageState:false,
      notificationBadgeInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
    getReqNotificationCountMethod(){
      return this.$store.getters.workspaceUserNotificationGetters;
    }
  },
  mounted () {
    this.notificationBadgeInfo = this.$store.getters.workspaceUserNotificationGetters.data;
    bus.$on('showHeaderbtn', (data) => {
      this.showBtn = data;
    });
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
    bus.$on('clearNotificationBadgeInfo', (data) => {
      this.notificationBadgeInfo = data;
    });
  },
  methods: {
    accessFeaturesOfPackagemethod(){
      this.accessFeaturesOfPackageState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      let covid_19_popup = document.querySelector(".covid_19_popup");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
        if(covid_19_popup){
          covid_19_popup.classList.add('moved_to_top_icon');
        }
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
          if(covid_19_popup){
          covid_19_popup.classList.remove('moved_to_top_icon');
          }
        }
    },
    logoutFromAllTabMethod() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logoutMethod(){
      this.$store.dispatch('logoutAction')
      .then(() => {
        this.logoutFromAllTabMethod();
      })
    },
    homeRedircet(){
      window.location.href = '/';
    }
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
    getReqNotificationCountMethod(newVal, oldVal){
      this.notificationBadgeInfo = newVal.data
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
}
